import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog"
import { Textarea } from "@/components/ui/textarea"
import { Button } from "@/components/ui/button"
import { toast } from "@/components/ui/use-toast"
import feedbackService from "@/modules/Feedback/service/feedbackService"
import { useAuth } from "@/modules/Auth/context/AuthContext"

interface FeedbackModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export function FeedbackModal({ isOpen, onOpenChange }: FeedbackModalProps) {
  const [feedback, setFeedback] = useState("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { user } = useAuth()

  const handleSubmit = async () => {
    if (!feedback.trim()) {
      toast({
        title: "Por favor, escreva seu feedback antes de enviar.",
        variant: "destructive",
      })
      return
    }

    setIsLoading(true)
    try {
      await feedbackService.sendFeedback(feedback, user.pesEmail)
      toast({
        title: "Feedback enviado com sucesso!",
        description: "Obrigado por nos ajudar a melhorar.",
      })
      setFeedback("")
      onOpenChange(false)
    } catch (error) {
      toast({
        title: "Erro ao enviar feedback",
        description: "Tente novamente mais tarde.",
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Enviar Feedback</DialogTitle>
          <DialogDescription>
            Aqui no Giants, construir é respirar o CO4. Deixe sua sugestão e nos ajude a melhorar a
            plataforma.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Textarea
            placeholder="Digite seu feedback aqui..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={5}
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Enviando..." : "Enviar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
